import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import {
  SwipeableDrawer,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import CartProductCard from "components/cards/CartProductCard";
import OrderSummary from "components/orderSummary/OrderSummary";
import { callPostApiWithAuth, callGetApiWithAuth } from "utils/api";
import { refreshStorage } from "utils/auth";
import ShippingAddressModal from "../checkout/ShippingAddressModal";
import CreditCardModal from "../checkout/CreditCardModal";

export default function MiniCart({
  open,
  toggleDrawer,
  showInventoryBtn,
  showCheckoutBtn,
  setShowInventoryBtn,
  setShowCheckoutBtn,
}) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.cart.products);
  const myUser = useSelector((state) => state.auth.user);
  const promotionCode = useSelector((state) => state.cart.promotionCode);
  const [shippingPrice, setShippingPrice] = useState(undefined);
  const [taxAmount, setTaxAmount] = useState(undefined);
  const [discountAmount, setDiscountAmount] = useState(undefined);
  const [isOpenedShippingEdition, setIsOpenedShippingEdition] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [hasCredit, setHasCredit] = useState(false);
  const [isOpenedBillingDetailModal, setIsOpenedBillingDetailModal] =
    useState(false);
  const [isInventoryLoading, setIsInventoryLoading] = useState(false);

  const getProductIdByVariant = (product) => {
    let productID = "";
    product?.variants?.forEach((variant_) => {
      if (variant_.variant * 1 === product.size * 1) {
        productID = variant_.id;
      }
    });
    return productID;
  };

  const onGetDiscountAmount = (data) => {
    setDiscountAmount(data.data.discount_code);
  };
  const getDiscountAmount = () => {
    if (!promotionCode) return;
    let orderDetails = products.map((el) => ({
      product_id: el.productType === "product" ? el.id : null,
      quantity: el.count,
    }));
    const data = {
      promoCode: promotionCode,
      orderDetails,
    };
    callPostApiWithAuth("shop/check/promo_code", data, onGetDiscountAmount);
  };
  const onGetTaxAmount = (data) => {
    setTaxAmount(data.data.taxAmount);
  };
  const onFailTax = (errMessage) => {
    
  };
  const getTaxAmount = () => {
    let orderDetails = products.map((el) => ({
      quantity: el.count,
      kit_id: el.productType === "kit" ? el.id : null,
      product_id: el.productType === "product" ? el.id : null,
    }));
    const data = {
      order: {
        shipping_price: shippingPrice || 0,
      },
      orderDetails: orderDetails,
    };
    callPostApiWithAuth("shop/check/tax", data, onGetTaxAmount, onFailTax);
  };
  const onGetShippingPrice = (data) => {
    let shippingPrice0 = data.data.shippingPrice;
    setShippingPrice(shippingPrice0);
  };
  const getShippingPrice = () => {
    let orderDetails = [];
    products.map((el) => {
      if (el.is_digital === 2) {
        orderDetails.push({ product_id: el.id, quantity: el.count });
      }
    });
    if (orderDetails.length > 0) {
      const data = {
        orderDetails,
      };
      callPostApiWithAuth(
        "shop/check/shipping_price",
        data,
        onGetShippingPrice
      );
    } else {
      // getTaxAmount()
    }
  };
  const handleClickCheckout = () => {
    // if (taxAmount == undefined) {
    //   setIsOpenedShippingEdition(true)
    // } else {
    //   if (hasCredit == false) {
    //     setIsOpenedBillingDetailModal(true)
    //   } else {
    history.push({
      pathname: "/shop/checkout",
      state: {
        editable: false,
      },
    });
    //   }
    // }
  };
  const loadUserData = () => {
    callGetApiWithAuth("profile", onGetUserData);
  };
  const onGetUserData = (data) => {
    // setUserData(data.data)
    dispatch({
      type: "auth.REFRESH",
      payload: { user: data.data },
    });
    refreshStorage(data.data);
    // getTaxAmount()
  };
  const afterUpdateSuccess = (successMessage) => {
    loadUserData();
    // setSuccessMessage(successMessage)
  };

  const onErrorMessage = (errorMessage) => {
    setErrorMessage(errorMessage);
  };

  const closeShippingEdition = () => {
    setIsOpenedShippingEdition(false);
    dispatch({
      type: "cart.CLOSE_SIDEBAR_CART",
    });
  };

  useEffect(() => {
    if (products.length == 0) {
      setShippingPrice(undefined);
    } else {
      getShippingPrice();
    }
  }, [products]);

  useEffect(() => {
    if (products.length == 0) {
      setTaxAmount(undefined);
    } else {
      if (shippingPrice != undefined) {
        // getTaxAmount()
      }
    }
  }, [products, shippingPrice]);

  useEffect(() => {
    if (myUser && myUser.billing_detail?.last_cc_4 != "none") {
      setHasCredit(true);
    }
  }, [myUser]);

  useEffect(() => {
    if (products.length == 0) {
      setDiscountAmount(undefined);
    } else {
      if (shippingPrice != undefined) {
        getDiscountAmount();
      }
    }
  }, [products, shippingPrice]);

  const handleCheckInventory = () => {
    setIsInventoryLoading(true);
    let orderDetails = products.map((el) => ({
      quantity: el.count,
      product_id: getProductIdByVariant(el),
    }));

    const data = {
      dist_center_id: 2,
      orderDetails: orderDetails,
    };
    callPostApiWithAuth(
      "shop/check/valid_inventory_detail",
      data,
      onSuccessCheckInventory,
      onFailCheckInventory
    );
  };

  const onSuccessCheckInventory = (data) => {
    setIsInventoryLoading(false);
    let invalid_status =
      data.data &&
      data.data.orderDetails.filter((el) => el.status === "invalid");

    invalid_status &&
      invalid_status.map((product) => {
        if (product.status === "invalid") {
          document.getElementsByClassName(
            "error-" + product.product_id
          )[0].style.display = "block";
        }
      });
    if (invalid_status.length <= 0) {
      let valid_status =
        data.data &&
        data.data.orderDetails.filter((el) => el.status === "valid");
      valid_status &&
        valid_status.map((product) => {
          if (product.status === "valid") {
            setShowCheckoutBtn(true);
            setShowInventoryBtn(false);
            document.getElementsByClassName(
              "error-" + product.product_id
            )[0].style.display = "block";
          }
        });
      data.data &&
        data.data.orderDetails.map((product) => {
          if (product.product_id) {
            document.getElementsByClassName(
              "error-" + product.product_id
            )[0].style.display = "none";
          }
        });
    } else {
      data.data &&
        data.data.orderDetails.map((product) => {
          if (product.status === "valid") {
            document.getElementsByClassName(
              "error-" + product.product_id
            )[0].style.display = "none";
          }
        });
    }
    if (invalid_status && invalid_status.length > 0) {
      return;
    }
    setTimeout(() => {
      handleClickCheckout();
    }, 1000);
  };

  const onFailCheckInventory = (errMessage) => {
    setIsInventoryLoading(false);
    setErrorMessage(errMessage);
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={() => toggleDrawer(false)}
      onOpen={() => toggleDrawer(true)}
      classes={{
        paper: classes.root,
      }}
    >
      <div className={classes.topRow}>
        <Typography component="h2" className={classes.title}>
          YOUR CART
        </Typography>
        <IconButton
          component="span"
          className={classes.close}
          onClick={() => toggleDrawer(false)}
        >
          <CloseIcon />
        </IconButton>
      </div>
      {products.map((product, index) => (
        <CartProductCard
          setShowCheckoutBtn={setShowCheckoutBtn}
          setShowInventoryBtn={setShowInventoryBtn}
          product={product}
          productId={getProductIdByVariant(product)}
          key={index}
        />
      ))}
      {products.length > 0 ? (
        <>
          <OrderSummary
            products={products}
            shippingPrice={shippingPrice}
            taxAmount={taxAmount}
            discountAmount={discountAmount}
          />
          <ShippingAddressModal
            isOpened={isOpenedShippingEdition}
            data={myUser}
            afterUpdateSuccess={afterUpdateSuccess}
            closeEdition={closeShippingEdition}
            onErrorMessage={onErrorMessage}
          />
          <CreditCardModal
            isOpened={isOpenedBillingDetailModal}
            data={myUser}
            afterUpdateSuccess={afterUpdateSuccess}
            closeEdition={() => setIsOpenedBillingDetailModal(false)}
            onErrorMessage={onErrorMessage}
            isSelectedTab="info"
          />
          <div className={classes.actions}>
            {/* {showCheckoutBtn ? (
              <Button
                variant="contained"
                color="primary"
                fullWidth
                className={clsx(classes.btn)}
                onClick={handleClickCheckout}
                // component={Link}
                // to={"/shop/checkout"}
              >
                Checkout
              </Button>
            ) : (
              ""
            )} */}
            {/* {showInventoryBtn ? ( */}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              className={clsx(classes.btn)}
              onClick={handleCheckInventory}
              // component={Link}
              // to={"/shop/checkout"}
            >
              {isInventoryLoading ? <CircularProgress size={24} /> : "Checkout"}
            </Button>
            {/* ) : (
              ""
            )} */}
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              className={clsx(classes.btn, classes.btnMargin)}
              onClick={() => toggleDrawer(false)}
            >
              Continue Shopping
            </Button>
          </div>
        </>
      ) : (
        <Typography component={"p"}>There are no items.</Typography>
      )}
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={errorMessage}
        autoHideDuration={2000}
        onClose={(e, r) => {
          if (r == "timeout") setErrorMessage("");
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setErrorMessage("")}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </SwipeableDrawer>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2.6),
    paddingRight: 23,
    width: 324,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
  },
  title: {
    fontWeight: 500,
  },
  close: {
    padding: 4,
  },
  actions: {
    marginTop: 23,
    marginBottom: 23,
  },
  btn: {
    textTransform: "capitalize",
  },
  btnMargin: {
    marginTop: 12,
  },
}));
